import React, { useEffect, useState } from 'react';
import { Checkbox, Col, Descriptions, Modal, Row, Select } from 'antd';
import { useTranslation } from 'react-i18next';

const EditFirmwareModal = (props) => {
  const { t } = useTranslation();
  const [applyToAll, setApplyToAll] = useState(false);
  const [selectedDeviceIds, setSelectedDeviceIds] = useState([]);

  const firmware = props.firmware;

  useEffect(() => {
    if (props.visible && firmware?.VERSION) {
      props.loadScope(firmware.VERSION);
    }
  }, [props.visible, firmware?.VERSION]);

  useEffect(() => {
    if (props.visible && props.firmwareScope?.RESULT) {
      setApplyToAll(Boolean(props.firmwareScope.APPLY_TO_ALL));
      setSelectedDeviceIds(props.firmwareScope.DEVICE_IDS || []);
    }
  }, [props.visible, props.firmwareScope]);

  const handleOk = () => {
    if (!firmware?.VERSION) {
      return;
    }

    props.updateScope(firmware.VERSION, applyToAll, selectedDeviceIds);
    props.close();
  };

  const deviceOptions = (props.devices || []).map((device) => ({
    label: device.MAC,
    value: String(device.MAC),
  }));

  return (
    <Modal
      title={t('FirmwarePage.editFirmwareModal.title') || 'Assign firmware scope'}
      open={props.visible}
      onOk={handleOk}
      onCancel={props.close}
      okText={t('Confirm') || 'Confirm'}
      cancelText={t('Cancel') || 'Cancel'}
    >
      <Descriptions column={1} bordered size="small">
        <Descriptions.Item label={t('FirmwarePage.table.version') || 'Version'}>
          {firmware?.VERSION || '-'}
        </Descriptions.Item>
        <Descriptions.Item label={t('FirmwarePage.table.description') || 'Description'}>
          {firmware?.DESCRIPTION || '-'}
        </Descriptions.Item>
        <Descriptions.Item label={t('FirmwarePage.table.lastModified') || 'Last Modified'}>
          {firmware?.UPLOADED_TIME || '-'}
        </Descriptions.Item>
      </Descriptions>

      <Row gutter={[16, 16]} style={{ marginTop: 16 }}>
        <Col span={24}>
          <Checkbox checked={applyToAll} onChange={(e) => setApplyToAll(e.target.checked)}>
            {t('FirmwarePage.editFirmwareModal.applyToAll') || 'Apply to all devices'}
          </Checkbox>
        </Col>
        <Col span={24}>
          <div style={{ marginBottom: 8 }}>
            {t('FirmwarePage.editFirmwareModal.selectDevices') || 'Select specific devices'}
          </div>
          <Select
            mode="multiple"
            style={{ width: '100%' }}
            options={deviceOptions}
            value={selectedDeviceIds}
            onChange={setSelectedDeviceIds}
            disabled={applyToAll}
            placeholder={t('FirmwarePage.editFirmwareModal.selectDevicesPlaceholder') || 'Choose devices'}
          />
        </Col>
      </Row>
    </Modal>
  );
};

export default EditFirmwareModal;
